export function parseQuery(rawQuery: string | null) {
  if (!rawQuery) {
    return {};
  }

  const queryObj: { [key: string]: string } = {};
  const query = (rawQuery[0] === '?' ? rawQuery.substr(1) : rawQuery).split('#')[0];

  const pairs = query.split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    queryObj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }

  return queryObj;
}
